import React , {useEffect} from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import AuthContext from '../AppAuthContext';
import { muiTheme } from '../../styling/Styles';
import ProjectQuality from './ProjectQuality';
import QualityPageBreadcrumb from './QualityPageBreadcrumb';
import loadPagesInfo from '../BuildApps/LoadPagesInfo';
import LoadQualitySpinner from './Spinners/LoadQualitySpinner';
import LoadSyncToGithubSpinner from './Spinners/LoadSyncToGithubSpinner';

// This component is used to render profile page.
const QualityPage = () => {

    const { state } =  React.useContext(AuthContext);
    const navigateState  = useLocation().state;
    const [init, setInit] = React.useState(false);
    const [selectedProject, setSelectedProject] = React.useState(-1);
    const [selectedPage, setSelectedPage] = React.useState(-1);
    const [loadAnalyticsSpinner, setLoadAnalyticsSpinner] = React.useState(false);
    const [loadGithubAnalyticsSpinner, setLoadGithubAnalyticsSpinner] = React.useState(false);
    const [loadPages,setLoadPages] = React.useState(false);

    useEffect(() => {
        if (init === false) {
          setInit(true);
          if(navigateState.projectName === undefined){
            const tempSelectedProject = localStorage.getItem('selectedProject');
            const tempSelectedPage = localStorage.getItem('selectedPage');
            setSelectedPage(tempSelectedPage);
            setSelectedProject(tempSelectedProject);
          }
          else{
            let tempSelectedProject = -1;
            JSON.parse(localStorage.getItem('data')).forEach( (project,index) => {
                if(project.name === navigateState.projectName){
                    tempSelectedProject = index;
                }
            })
            setSelectedProject(tempSelectedProject);
            localStorage.setItem('selectedProject',tempSelectedProject);
            localStorage.setItem('selectedPage',-1);
          }
         
        }
    }, [init]);

    useEffect( () => {
        if (selectedProject !== -1){
            loadPagesInfo(setLoadPages);
        }
    },[selectedProject])

    // This statement is used to go to login page if user clicks on logout
    if (!state.isLoggedIn) {
        return <Navigate to="/login" />;
    }

    return(

        <ThemeProvider theme={muiTheme}>
            <div style={{height: '100%', overflow: 'auto'}}>  
                <WabliAppBar/>
                <QualityPageBreadcrumb
                    selectedPage={selectedPage}
                    selectedProject={selectedProject}
                    setSelectedPage={setSelectedPage}
                    setSelectedProject={setSelectedProject}
                />
                <ProjectQuality
                    selectedProject={selectedProject}
                    setLoadAnalyticsSpinner={setLoadAnalyticsSpinner}
                    setLoadGithubAnalyticsSpinner={setLoadGithubAnalyticsSpinner}
                    loadPages={loadPages}
                />
                <div style={{marginTop: '1rem'}}/>
                <LoadQualitySpinner 
                    loadAnalyticsSpinner={loadAnalyticsSpinner}
                />
                <LoadSyncToGithubSpinner
                    loadGithubAnalyticsSpinner={loadGithubAnalyticsSpinner}
                />
            </div>            
           
        </ThemeProvider>
    )

}

export default QualityPage;